import "./Terms.module.css";
import Navigation from "@/reusable_sections/Header";
import Terms from "./sections/Terms";
import Footer from "@/reusable_sections/Footer";
export default function TermsPage() {
  return <div>
      <Navigation />
      <Terms />
      <Footer />
    </div>;
}